/* src/app/shared/components/ngx-responsive-table/mobile.scss */
@media screen and (max-width: 599px) {
  .ngx-responsive-table ::ng-deep table {
    display: block;
  }
  .ngx-responsive-table ::ng-deep table thead {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }
  .ngx-responsive-table ::ng-deep table thead tr th,
  .ngx-responsive-table ::ng-deep table tbody tr td {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }
  .ngx-responsive-table ::ng-deep table thead tr th::before,
  .ngx-responsive-table ::ng-deep table tbody tr td::before {
    content: attr(data-title);
    color: #969696;
    font-size: 0.8em;
  }
  .ngx-responsive-table ::ng-deep table tbody {
    display: block;
  }
  .ngx-responsive-table ::ng-deep table tbody tr {
    display: block;
    position: relative;
    transition: padding 0.3s ease;
  }
  .ngx-responsive-table ::ng-deep table tbody tr.collapsed {
    max-height: 3.3333333333em;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: flex-start;
    padding-right: 2.5em;
  }
  .ngx-responsive-table ::ng-deep table tbody tr.collapsed.fixed-cell-width {
    flex-wrap: wrap;
  }
  .ngx-responsive-table ::ng-deep table tbody tr.collapsed.fixed-cell-width td {
    width: 33%;
  }
  .ngx-responsive-table ::ng-deep table tbody tr.collapsed td {
    display: inline-flex;
  }
  .ngx-responsive-table ::ng-deep table tbody tr.collapsed td[collapsed-order="0"] {
    order: 0;
  }
  .ngx-responsive-table ::ng-deep table tbody tr.collapsed td[collapsed-order="1"] {
    order: 1;
  }
  .ngx-responsive-table ::ng-deep table tbody tr.collapsed td[collapsed-order="2"] {
    order: 2;
  }
  .ngx-responsive-table ::ng-deep table tbody tr.collapsed td[collapsed-order="3"] {
    order: 3;
  }
  .ngx-responsive-table ::ng-deep table tbody tr.collapsed td[collapsed-order="4"] {
    order: 4;
  }
  .ngx-responsive-table ::ng-deep table tbody tr.collapsed td[collapsed-order="5"] {
    order: 5;
  }
  .ngx-responsive-table ::ng-deep table tbody tr.collapsed td[collapsed-order="6"] {
    order: 6;
  }
  .ngx-responsive-table ::ng-deep table tbody tr.collapsed td[collapsed-order="7"] {
    order: 7;
  }
  .ngx-responsive-table ::ng-deep table tbody tr.collapsed td[collapsed-order="8"] {
    order: 8;
  }
  .ngx-responsive-table ::ng-deep table tbody tr.collapsed td[collapsed-order="9"] {
    order: 9;
  }
  .ngx-responsive-table ::ng-deep table tbody tr.collapsed td[collapsed-order="10"] {
    order: 10;
  }
  .ngx-responsive-table ::ng-deep table tbody tr.collapsed td:not([collapsed-order="0"]):not([collapsed-order="1"]):not([collapsed-order="2"]):not([collapsed-order="3"]):not([collapsed-order="4"]):not([collapsed-order="5"]):not([collapsed-order="6"]):not([collapsed-order="7"]):not([collapsed-order="8"]):not([collapsed-order="9"]):not([collapsed-order="10"]) {
    display: none;
  }
  .ngx-responsive-table ::ng-deep table tbody tr td {
    flex: 1 0 auto;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .ngx-responsive-table ::ng-deep table tbody tr ngx-toggle-switch {
    display: block;
    position: absolute;
    top: 0.9em;
    right: 1em;
    transition: top 0.3s ease;
  }
}
/*# sourceMappingURL=mobile.css.map */
